import Container from '@mui/material/Container'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Client } from '../../@types/common'
import { getClients } from '../../store/actions'
import { State } from '../../store/types'
import { message } from '../../utils/toast'
import { Utils } from '../../utils/utils'
import ClientsGrid from '../ClientsGrid/ClientsGrid'
import style from './ClientsGridRoute.module.css'

interface Props {}

const ClientsGridRoute = (props: Props) => {
  const dispatch = useDispatch()
  const google = useSelector((state: State) => state.app.googleAccount)

  const clients = useSelector<State, Client[]>(
    (state: State) => state.app.clients,
  )
  const isClientsLoading = useSelector<State, boolean>(
    (state: State) => state.app.isClientsLoading,
  )

  const handleCopy = (value: string) => {
    Utils.copyTextToClipboard(value)
    message.success('Copied!')
  }

  useEffect(() => {
    dispatch(getClients())
  }, [dispatch])

  return (
    <div className={style.root}>
      <Container>
        <ClientsGrid
          isLoading={isClientsLoading}
          // clients={clients.filter((c) => c.client.length)}
          clients={clients?.sort((a: Client, b: Client): number =>
            a.client > b.client ? -1 : 1,
          )}
          owner={google?.profileObj.email.split('@')[0]}
          onCopy={handleCopy}
        />
      </Container>
    </div>
  )
}

export default ClientsGridRoute
